module.exports = __webpack_public_path__ + "img/02-04-img-04@2x.4d9ef705.png";